import { Modal, Button } from "react-bootstrap";
import Collapsible from "react-collapsible";
import React, { useState, useEffect, useHistory } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import Loader from "../Loader";
import { Formik, Form, ErrorMessage, Field, useFormik } from "formik";
import * as Yup from "yup";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const basicSchema = Yup.object().shape({
  plateNumber: Yup.string().required("Plate Number is required"),
  model: Yup.string().required("Vehicle Model is required"),
  color: Yup.string().required("Color is required"),
  driverId: Yup.string().required("Please select driver"),
  vehicleTypeId: Yup.string().required("Please select vehicle Type"),
  manufacturedYear: Yup.date()
    .nullable()
    .required("Manufactured Year is required")
    .max(new Date(), "Start Date must be earlier than today"),
  documents: Yup.mixed().required("Document is required"),
  vehicleImage: Yup.mixed().required("Please select Image"),
  tradeLicence: Yup.mixed().required("Please Upload Trade Licence"),
  insurance: Yup.mixed().required("Please Upload Docunent"),
});

const Edit = ({ showModal, hideModal, id, data, getVehicles }) => {
  const history = useNavigate();
  let [loading, setLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState(true);
  const [drivers, setDrivers] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const getDrivers = async () => {
    const response = await axios
      .get("/drivers")
      .then((res) => {
        setDrivers(res.data);
      })
      .catch((err) => {
        notifyError();
      });
  };

  const getVehicleTypes = async () => {
    const response = await axios
      .get("/vehicleTypes")
      .then((res) => {
        setVehicleTypes(res.data);
      })
      .catch((err) => {
        notifyError();
      });
  };
  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    editVehicle(values);
    setLoading(true);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      plateNumber: data.plateNumber,
      model: data.model,
      color: data.color,
      vehicleTypeId: data.vehicleTypeId,
      manufacturedYear: data.manufacturedYear,
      driverId: data.driverId,
      vehicleImage: data.vehicleImage,
      documents: data.documents,
      tradeLicence: data.tradeLicence,
      insurance: data.insurance,
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          onChange(name, val);
        }}
      />
    );
  };
  const notifySuccess = () =>
    toast.info("Driver info Updated.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const editVehicle = async (e, i) => {
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
        bodyFormData.append("id", id);
      }

      const response = await axios
        .post("/vehicle/" + id, bodyFormData)
        .then((res) => {
          history("/vehicleList");
          setLoading(false);
          hideModal();
          notifySuccess();
          getVehicles();
        })
        .catch((err) => {
          setErrorMsg(err.response.data.msg);
          setLoading(false);
          notifyError();
        });
    } catch (err) {
      console.log("errr", err);
      setLoading(false);
      notifyError();
    }
  };

  useEffect(() => {
    getVehicleTypes();
    getDrivers();
  }, []);

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
       style={{marginTop: "60px"}} 
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div
              style={{
                position: "absolute",
                zIndex: "1000",
                top: 50 + "%",
                left: 50 + "%",
              }}
            >
              <Loader />
            </div>
          )}

          <div class="row">
            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Plate Number</label>
                    <input
                      type="text"
                      name="plateNumber"
                      value={values.plateNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.plateNumber && touched.plateNumber
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.plateNumber && touched.plateNumber && (
                      <p className="error">{errors.plateNumber}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Model</label>
                    <input
                      type="text"
                      name="model"
                      value={values.model}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.model && touched.model
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.model && touched.model && (
                      <p className="error">{errors.model}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Color</label>
                    <input
                      type="text"
                      id="inputName"
                      name="color"
                      value={values.color}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.color && touched.color
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.color && touched.color && (
                      <p className="error">{errors.color}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputEstimatedBudget">Manufactured Year</label>

                    <DatePickerField
                      name="manufacturedYear"
                      id="inputEstimatedBudget"
                      class="form-control"
                      value={values.manufacturedYear}
                      onChange={setFieldValue}
                      className={
                        errors.manufacturedYear && touched.manufacturedYear
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.manufacturedYear && touched.manufacturedYear && (
                      <p className="error">{errors.manufacturedYear}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Vehicle Type</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="vehicleTypeId"
                      value={values.vehicleTypeId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.vehicleTypeId && touched.vehicleTypeId
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Vehicle Type</option>
                      {vehicleTypes.map((vehicleType, index) => {
                        return (
                          <option key={vehicleType.id} value={vehicleType.id}>
                            {vehicleType.typeName}
                          </option>
                        );
                      })}
                    </select>
                    {errors.vehicleTypeId && touched.vehicleTypeId && (
                      <p className="error">{errors.vehicleTypeId}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Driver</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="driverId"
                      value={values.driverId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.driverId && touched.driverId
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Driver</option>
                      {drivers.map((driver, index) => {
                        return (
                          <option key={driver.id} value={driver.id}>
                            {driver.firstName} {driver.lastName}
                          </option>
                        );
                      })}
                    </select>
                    {errors.driverId && touched.driverId && (
                      <p className="error">{errors.driverId}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card card-success">
                <div className="card-body">
                  <div class="form-group">
                    <label for="exampleInputFile">Vehicle Image</label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={
                          process.env.REACT_APP_BASE_URL + values.vehicleImage
                        }
                        height="300px"
                        width="300px"
                        alt="vehicle picture"
                      />
                    </Collapsible>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFile"
                          name="vehicleImage"
                          accept="image/*"
                          onChange={(e) =>
                            setFieldValue(
                              "vehicleImage",
                              e.currentTarget.files[0]
                            )
                          }
                          className={
                            errors.vehicleImage && touched.vehicleImage
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.vehicleImage && touched.vehicleImage && (
                      <p className="error">{errors.vehicleImage}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Legal Documents</label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={process.env.REACT_APP_BASE_URL + values.documents}
                        height="300px"
                        width="300px"
                        alt="vehicle picture"
                      />
                    </Collapsible>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="documents"
                          onChange={(event) => {
                            setFieldValue(
                              "documents",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.documents && touched.documents
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.documents && touched.documents && (
                      <p className="error">{errors.documents}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Trade Licence</label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={
                          process.env.REACT_APP_BASE_URL + values.tradeLicence
                        }
                        height="300px"
                        width="300px"
                        alt="tradeLicence picture"
                      />
                    </Collapsible>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="tradeLicence"
                          onChange={(event) => {
                            setFieldValue(
                              "tradeLicence",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.tradeLicence && touched.tradeLicence
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.tradeLicence && touched.tradeLicence && (
                      <p className="error">{errors.tradeLicence}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Insurance</label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={process.env.REACT_APP_BASE_URL + values.insurance}
                        height="300px"
                        width="300px"
                        alt="insurance picture"
                      />
                    </Collapsible>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="insurance"
                          onChange={(event) => {
                            setFieldValue(
                              "insurance",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.insurance && touched.insurance
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.insurance && touched.insurance && (
                      <p className="error">{errors.insurance}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {errorMsg && (
            <div>
              <h5 className="error">{errorMsg}</h5>
            </div>
          )}
          <button className="btn btn-error" onClick={hideModal}>
            Cancel
          </button>

          <button
            disabled={isSubmitting}
            onClick={submitForm}
            className="btn btn-success"
            type="submit"
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default Edit;
